import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./NewPotFolder.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { TextField } from "@mui/material";
import apiManager from '../../ApiManager';
const NewPotFolder = ({ setModalType, arg }) => {
    const [inProp, setInProp] = useState(false);
    const [name, set_name] = useState("");
    useEffect(() => {
        console.log("NewPotFolder");
        setInProp(true);
    }, [])
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "NewPotFolder"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>


                                <div className={styleUi.content}>
                                    <div className={styleUi.title}>
                                        新增清單
                                    </div>
                                    <TextField fullWidth id="outlined-basic" value={name} onChange={e => {
                                        const input = e.target.value;
                                        const maxLen = 30;
                                        if (input.length <= maxLen) {
                                            set_name(input);
                                        } else {
                                            set_name(input.slice(0, maxLen));
                                        }
                                    }} label="清單名稱" variant="outlined" />
                                    <button className={`${allStyle.btnGray1} ${styleUi.btn}`} onClick={e => {
                                        apiManager.fetchPost("pocket-list",{
                                            pocket_lists_name:name
                                          }).then(res=>{
                                            console.log(res);
                                            arg.cb(res)
                                            setInProp(false);
                                          }).catch(err=>{
                                            console.log(err);
                                            alert(err.message);
                                          })
                                        
                                    }}>
                                        儲存
                                    </button>
                                </div>

                                <IconButton className={styleUi.close} onClick={e => {
                                    setInProp(false);
                                }}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(NewPotFolder);